import {
  BaseWidgetProperties,
  ButtonSizeOptions,
  ButtonTypes,
} from '@finxone-platform/shared/sys-config-types';
import {
  commonNotificationDescriptionTextWidget,
  commonNotificationHeaderTextWidget,
  commonNotificationImageWidget,
  commonNotificationQuickLinkWidget,
  commonTextWidgetAccountInformation,
  commonTextWidgetTransactionAccountInformation,
} from '../utils/notification-utils';

export const notificationTransactionSuccessWidgets = [
  commonNotificationImageWidget({
    configDisplayName: 'Image Widget: Success Icon',
    attributes: {
      widgetProperties: {
        textContent: '',
        imageAssetUrl: 'assets/images/success.svg',
      } as BaseWidgetProperties,
    },
  }),
  commonNotificationHeaderTextWidget({
    text: '<div class="w-100"><p class="m-0">Transaction Successful</p></div>',
    configDisplayName: 'Transaction Successful Header',
  }),
  commonNotificationDescriptionTextWidget({
    text: '<div class="w-100"><p>Your transaction has been completed successfully. If you have any questions or concerns, please feel free to contact our customer support.</p></div>',
    configDisplayName: 'Description Text',
  }),
  ...commonTextWidgetTransactionAccountInformation,
  ...commonTextWidgetAccountInformation,
  commonNotificationQuickLinkWidget(
    'Quick Link: Confirm & Close',
    'Confirm & Close',
    true,
    `${ButtonTypes.SECONDARY} ${ButtonSizeOptions.FULL_WIDTH}`,
  ),
];
